export default __webpack_public_path__ + "static/media/home-hero.0a4f6d66.png";